import { render, staticRenderFns } from "./excelRecord.vue?vue&type=template&id=b5db4484&scoped=true&"
import script from "./excelRecord.vue?vue&type=script&lang=js&"
export * from "./excelRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5db4484",
  null
  
)

export default component.exports